export default __webpack_public_path__ + "img/espace-dessous-petit.png";